import httpClient from 'api/httpClient';
import publicHttpClient from 'api/publicHttpClient';

function signup(values: any) {
  return publicHttpClient.post('auth/signup', values);
}

function updateVendorEnquiry(values: any) {
  return httpClient.post('users/update-vendor-enquiry', values);
}

export default {
  signup,
  updateVendorEnquiry,
};
